import { SearchOutlined } from '@ant-design/icons'
import { Button, Input } from 'antd'
import styled from 'styled-components'
import { IconFont } from '../iconfont'

interface ButtonProps extends React.ComponentProps<typeof Button> {}

interface SearchInputProps {
  containerProps?: typeof Warningontainer
  buttonProps?: ButtonProps
  style?: React.CSSProperties
  text: React.ReactNode
  textStyle?: React.CSSProperties
  iconStyle?: React.CSSProperties
}

export const Warning = (props: SearchInputProps) => {
  const { buttonProps, containerProps, style, text, textStyle, iconStyle } = props
  return (
    <Warningontainer {...containerProps} style={style}>
      <div style={{ display: 'flex' }}>
        <WarningIconFont type={'icon-tixingshixin'} style={iconStyle} />
        <div className="text" style={textStyle}>
          {text}
        </div>
      </div>
    </Warningontainer>
  )
}

const Warningontainer = styled.div`
  width: 511px;
  background-color: #fff3e1;
  height: 34px;
  border-radius: 6px;
  display: flex;
  padding: 0 16px;
  align-items: center;
  border: 1px solid #ffad31;
  .text {
    margin: 0;
    font-size: 12px;
    color: #ffad31;
  }
`

const WarningIconFont = styled(IconFont)`
  color: #ffad31;
  margin-right: 10px;
`
